
import { Vue, Component } from "vue-property-decorator"

@Component
export default class Header1 extends Vue {}
